import * as React from "react";
import Grid from "@mui/material/Grid";
import { CmpTypographyField } from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Typography } from "@mui/material";
export const SummaryCard = ({ data = [], onClick = () => {} }) => {
 
  return (
     
    <Grid container spacing={1} className="easy-putaway-container mt-1">
      {data.map((item, index) => (
        <Grid item xs={12} sm={12} md={12} key={index} onClick={() => {
                  let items = { row: item };
                  onClick(items);
                }}
                // style={{ display: 'flex' }}
                >
          <div 
          className="easy-putaway-card" 
           style={{
            // display: 'flex',
            // flexDirection: 'column',
            // justifyContent: 'space-between', // Ensures content is spaced equally
            // flexGrow: 1, // This allows the card to grow and take up equal height 
            // maxHeight: '210px', // Set a max height for the cards
            // overflowY: 'auto', // Add scroll if content exceeds the height
          }}>
            <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
            <Grid item xs={6} md={2}>
                <Typography variant="subtitle1" className="label">
               VocTyp
                </Typography>
              </Grid>
              <Grid item xs={6} md={2}>
                <Typography variant="body1" className="value">
                  {item.L_VocTyp}
                </Typography>
              </Grid>
              
              <Grid item xs={6} md={2}>
                <Typography variant="subtitle1" className="label">
                VocTypName
                </Typography>
              </Grid>
              <Grid item xs={6} md={2}>
                <Typography variant="body1" className="value">
                 {item.L_VocTypName} 
                </Typography>
              </Grid>
              
             
              <Grid item xs={6} md={2}>
                <Typography variant="subtitle1" className="label" >
                VocNo
                </Typography>
              </Grid>
              <Grid item xs={6} md={2}>
                <Typography variant="body1" className="value">
                  {item.L_VocNo}
                </Typography>
              </Grid>
              <Grid item xs={6} md={2}>
                <Typography variant="subtitle1" className="label" >
                Party
                </Typography>
              </Grid>
              <Grid item xs={6} md={2}>
                <Typography variant="body1" className="value">
                  {item.Party}
                </Typography>
              </Grid>
              <Grid item xs={6} md={2}>
                <Typography variant="subtitle1" className="label" >
                PartyName
                </Typography>
              </Grid>
              <Grid item xs={6} md={2}>
                <Typography variant="body1" className="value">
                  {item.PartyName}
                </Typography>
              </Grid>
              
              
              
            
             
            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
